import { Pipe, PipeTransform } from '@angular/core';
import { getAvatarColor } from '../common/utils';

@Pipe({
  name: 'avatarColor',
  standalone: true,
})
export class AvatarColorPipe implements PipeTransform {
  transform(value: string): string {
    return getAvatarColor(value);
  }
}
